import { useNavigate } from "react-router-dom";
import TableIconCell from "../common/table/TableIconCell";
import TableCell from "../common/table/tableCell";

const Row = (props: any) => {
  const navigate = useNavigate();

  return (
    <tr
      className="tablePharmacies"
      onClick={() =>
        navigate(`/enrollment/citizen-detail/${props.citizen._id}`)
      }
    >
      <TableCell label={props.citizen.fiscalcode} class="column-width" />
      <TableCell label={props.citizen.name} />
      <TableCell label={props.citizen.surname} />
      <TableIconCell icon="chevron_right" />
    </tr>
  );
};

export default Row;
